import React from "react";
import { Button } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import logo from "../../../Assets/Images/logo.svg";
import adminlogo from "../../../Assets/Icons/encrypted.svg";
import managerlogo from "../../../Assets/Icons/delivery_truck_speed.svg";
import vendorlogo from "../../../Assets/Icons/local_gas_station_black.svg";
import logoCompany from "../../../Assets/Icons/companylogo.svg";
import "./style.css";

const SHOW_ADMIN_LOGIN = false;

const Select = ({ setUser }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);

  const handleAdminLogin = () => {
    setLoading(true);
    setUser("public_admin");
    navigate("/login-admin");
    setLoading(false);
  };

  const handleManagerLogin = () => {
    setLoading(true);
    setUser("public_manager");
    navigate("/login-manager");
    setLoading(false);
  };

  const handleVendorLogin = () => {
    setLoading(true);
    setUser("public_vendor");
    navigate("/login-vendor");
    setLoading(false);
  };

  return (
    <div className="select">
      <div className="select-page">
        <div className="logo">
          <img src={logo} alt="logo" />
        </div>

        <div className="select-card">
          <div className="top-gradient"></div>

          <div className="content-heading">Welcome Back</div>
          <div className="sub-heading">Select your role to continue</div>

          <div className="forms">
            {SHOW_ADMIN_LOGIN && (
              <div className="role-form">
                <div className="icon">
                  <img src={adminlogo} alt="logoAdmin" />
                </div>
                <div className="form-heading">System Administrator</div>
                <div className="form-sub-heading">
                  Manage platform, users, and system operations
                </div>
                <Button
                  type="primary"
                  className="submit-button"
                  loading={loading}
                  onClick={handleAdminLogin}
                >
                  Login as Admin <ArrowRightOutlined />
                </Button>
              </div>
            )}

            <div className="role-form">
              <div className="icon">
                <img src={managerlogo} alt="logoManager" />
              </div>
              <div className="form-heading">Fleet Manager</div>
              <div className="form-sub-heading">
                Manage vehicles, drivers, and fuel operations
              </div>
              <Button
                type="primary"
                className="submit-button"
                loading={loading}
                onClick={handleManagerLogin}
              >
                Login as Fleet Manager <ArrowRightOutlined />
              </Button>
            </div>

            <div className="role-form">
              <div className="icon">
                <img src={vendorlogo} alt="logoVendor" />
              </div>
              <div className="form-heading">Fuel Vendor</div>
              <div className="form-sub-heading">
                Manage fuel supply, pricing, and delivery operations
              </div>
              <Button
                type="primary"
                className="submit-button"
                loading={loading}
                onClick={handleVendorLogin}
              >
                Login as Fuel Vendor <ArrowRightOutlined />
              </Button>
            </div>
          </div>
        </div>

        <div className="logo-wrapper">
          <img src={logoCompany} alt="Logo Icon" className="logo-icon" />
          <div className="text">
            Powered by <span>CouSync</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Select;
